import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Models } from '../../models/global.models';

function createInitialState(): Models.LoanOfficerInformationLeadForm {
  return <Models.LoanOfficerInformationLeadForm>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'loan-officer-lead-store' })
export class LoanOfficerInformationLeadStore extends Store<Models.LoanOfficerInformationLeadForm> {
  constructor() {
    super(createInitialState());
  }
}
